import { arrayOf } from 'prop-types';
import React from 'react';
import { Card, CardFooter, CardImg } from 'reactstrap';

import {
  mediaSetRequirementShape,
  requirementShape,
} from '../../../prop-types';
import { CREATIVE_FILE_TYPES } from '../../constants';
import CreativesMediaSet from '../../CreativesMediaSet/CreativesMediaSet';
import SizeThumbnail from './SizeThumbnail';

export default function PossibleMediaSets({
  mediaSetRequirements,
  requirements,
}) {
  return (
    <ul className="list-inline text-muted small">
      {mediaSetRequirements.map((mediaSetRequirement, index) => {
        const linkedRequirements = requirements.filter(({ id }) =>
          mediaSetRequirement.requirementIds.includes(id),
        );

        return (
          <li className="list-inline-item" key={mediaSetRequirement.id}>
            <CreativesMediaSet name={`Option ${index + 1}`} compact>
              <ul className="list-unstyled list-inline mb-0">
                {linkedRequirements.map(requirement => {
                  const fileType =
                    CREATIVE_FILE_TYPES[requirement.requirements.fileType];
                  return (
                    <li className="list-inline-item" key={requirement.id}>
                      <Card className="align-items-center">
                        <CardImg
                          tag={SizeThumbnail}
                          requirement={requirement}
                          top
                        />
                        <CardFooter className="px-2 py-1 bg-white text-muted small text-center w-100">
                          {requirement.sizeType}
                          <br />({fileType})
                        </CardFooter>
                      </Card>
                    </li>
                  );
                })}
              </ul>
            </CreativesMediaSet>
          </li>
        );
      })}
    </ul>
  );
}

PossibleMediaSets.propTypes = {
  requirements: arrayOf(requirementShape.isRequired).isRequired,
  mediaSetRequirements: arrayOf(mediaSetRequirementShape.isRequired).isRequired,
};
